/**
 * VerifyBlock — email-verification wall shown when a logged-in user has
 * not yet clicked the verification link. Extracted from App.js as part
 * of the Feb 2026 RouteGuard consolidation so it can be composed
 * independently.
 *
 * Displays a friendly notice + a Sign-out escape hatch. The admin/broker
 * paths bypass this component entirely (see RouteGuard).
 */
import { useAuth } from "@/context/AuthContext";
import ComplianceFooter from "@/components/landing/ComplianceFooter";

export default function VerifyBlock() {
    const { user, logout } = useAuth();
    return (
        <div className="min-h-screen flex flex-col" data-testid="verify-block">
            <div className="flex-1 flex items-center justify-center p-8">
                <div className="max-w-md text-center">
                    <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-primary/10 text-primary flex items-center justify-center font-extrabold text-2xl">
                        ✉
                    </div>
                    <h1 className="text-3xl font-extrabold tracking-tight mb-2">
                        Verify your email to continue
                    </h1>
                    <p className="text-sm text-muted-foreground">
                        We've sent a verification link to{" "}
                        <span className="mono">{user.email}</span>. Click it to unlock your terminal.
                    </p>
                    <button
                        className="mt-6 text-xs text-primary hover:underline"
                        onClick={logout}
                        data-testid="verifyblock-logout"
                    >
                        Sign out
                    </button>
                </div>
            </div>
            <ComplianceFooter />
        </div>
    );
}
